import { Nullable } from '@ps/utils';

export interface SurveyManagementState {
  readonly buyerProjectManagerUpdating: boolean;
  readonly operatorProjectManagerUpdating: boolean;
  readonly error: Nullable<string>;
}

export const INITIAL_SURVEY_MANAGEMENT_STATE: SurveyManagementState = {
  buyerProjectManagerUpdating: false,
  operatorProjectManagerUpdating: false,
  error: null,
};
